import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
} from '@mui/material';

const PermissionsMatrix = ({
  permissions,
  onPermissionChange,
  permissionSchema = [],
  title = 'Permissions',
}) => {
  const hasPermission = (templateKey, childKey, permission) => {
    return permissions[templateKey]?.[childKey]?.includes(permission) || false;
  };

  const handlePermissionToggle = (
    templateKey,
    childKey,
    permission,
    checked,
  ) => {
    onPermissionChange(templateKey, childKey, permission, checked);
  };

  return (
    <Box>
      <Typography variant='h6' gutterBottom>
        {title}
      </Typography>
      <TableContainer component={Paper} variant='outlined'>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Permission</TableCell>
              <TableCell align='center' sx={{ fontWeight: 'bold' }}>
                Access
              </TableCell>
              <TableCell align='center' sx={{ fontWeight: 'bold' }}>
                Update
              </TableCell>
              <TableCell align='center' sx={{ fontWeight: 'bold' }}>
                Download
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {permissionSchema.map((module) => (
              <React.Fragment key={module.key}>
                <TableRow sx={{ backgroundColor: 'grey.50' }}>
                  <TableCell sx={{ fontWeight: 'bold' }}>
                    {module.title}
                  </TableCell>
                  <TableCell align='center'>
                    <Switch
                      checked={hasPermission(module.key, 'viewPage', 'read')}
                      onChange={(e) =>
                        handlePermissionToggle(
                          module.key,
                          'viewPage',
                          'read',
                          e.target.checked,
                        )
                      }
                      size='small'
                    />
                  </TableCell>
                  <TableCell align='center'></TableCell>
                  <TableCell align='center'></TableCell>
                </TableRow>
                {module.children.map((child) => (
                  <TableRow key={child.key}>
                    <TableCell sx={{ pl: 4 }}>{child.title}</TableCell>
                    {['read', 'write', 'download'].map((permission) => (
                      <TableCell key={permission} align='center'>
                        <Switch
                          checked={hasPermission(
                            module.key,
                            child.key,
                            permission,
                          )}
                          onChange={(e) =>
                            handlePermissionToggle(
                              module.key,
                              child.key,
                              permission,
                              e.target.checked,
                            )
                          }
                          disabled={
                            !child.availablePermissions.includes(permission) ||
                            !hasPermission(module.key, 'viewPage', 'read')
                          }
                          size='small'
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </React.Fragment>
            ))}

            {permissionSchema.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align='center' sx={{ py: 4 }}>
                  <Typography variant='body2' color='text.secondary'>
                    Loading permissions...
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PermissionsMatrix;
